import 'SF/student/intake/ItemPanel.js';
import 'SF/student/intake/QuestionPanel.js';
import 'SF/degreeplanner/AGIframePanel.js';
import 'SF/student/AGPlansPanel.js';
import 'SF/student/AbstractPlanPanel.js';
import 'SF/student/AcademicPlanDetailsPanel.js';
import 'SF/student/AcademicPlanEnrollmentsPanel.js';
import 'SF/student/AcademicPlanIntroductionWindow.js';
import 'SF/student/AcademicPlanManualMoveEnrollmentWindow.js';
import 'SF/student/AcademicPlanManualMoveRequirementWindow.js';
import 'SF/student/AcademicPlanPanel.js';
import 'SF/student/AcademicPlanPopup.js';
import 'SF/student/AcademicPlanRequirementsPanel.js';
import 'SF/student/AcademicPlanTermPanel.js';
import 'SF/student/AcademicPlanUtil.js';
import 'SF/student/AcademicPlanWindow.js';
import 'SF/student/ActionPlanDataView.js';
import 'SF/student/ActionPlanPopup.js';
import 'SF/student/ActiveConcernsChart.js';
import 'SF/student/AdmissionsInfoPanel.js';
import 'SF/student/AppointmentsGridPanel.js';
import 'SF/student/AppointmentsPanel.js';
import 'SF/student/CohortInfoPanel.js';
import 'SF/student/CourseAverageChart.js';
import 'SF/student/CourseChart.js';
import 'SF/student/CourseSectionComboBox.js';
import 'SF/student/CoursesDataPanel.js';
import 'SF/student/CoursesFilterPanel.js';
import 'SF/student/CoursesPanel.js';
import 'SF/student/DemographicsInfoPanel.js';
import 'SF/student/EnrollmentDDPanel.js';
import 'SF/student/FolderInfoPanel.js';
import 'SF/student/FolderPanel.js';
import 'SF/student/FolderTabPanel.js';
import 'SF/student/InfoPanel.js';
import 'SF/student/IntakePopup.js';
import 'SF/student/InterventionPopup.js';
import 'SF/student/InterventionsFilterPanel.js';
import 'SF/student/InterventionsGridPanel.js';
import 'SF/student/InterventionsPanel.js';
import 'SF/student/NotesFilterPanel.js';
import 'SF/student/NotesGridPanel.js';
import 'SF/student/NotesPanel.js';
import 'SF/student/NotesRowExpander.js';
import 'SF/student/OverviewPanel.js';
import 'SF/student/PlanDragNDropPanel.js';
import 'SF/student/PlansDataPanel.js';
import 'SF/student/PlansFilterPanel.js';
import 'SF/student/PlansPanel.js';
import 'SF/student/ProgramRequirementCommentWindow.js';
import 'SF/student/ProgramRequirementOverrideWindow.js';
import 'SF/student/ProgramsInfoPanel.js';
import 'SF/student/RecentFlagsDataView.js';
import 'SF/student/RetentionScorePanel.js';
import 'SF/student/StudentAttributeDataView.js';
import 'SF/student/StudentFileDataView.js';
import 'SF/student/StudentFolderToolbar.js';
import 'SF/student/StudentInfoDataView.js';
import 'SF/student/StudentInfoUtil.js';
import 'SF/student/StudentIntakePanel.js';
import 'SF/student/SuccessNetworkDataView.js';
import 'SF/student/SuccessNetworkPanel.js';
import 'SF/student/SuccessPlanPanel.js';
import 'SF/student/TermStatusInfoPanel.js';
import 'SF/student/bundle.js';
import 'SF/student/data/AcademicPlanTemplateStore.js';
import 'SF/student/data/AcademicPlansStore.js';
import 'SF/student/data/ActionPlanStore.js';
import 'SF/student/data/ActiveConcernsChartStore.js';
import 'SF/student/data/AppointmentsStore.js';
import 'SF/student/data/CourseAverageStore.js';
import 'SF/student/data/CourseStore.js';
import 'SF/student/data/CoursesAppointmentStore.js';
import 'SF/student/data/CoursesAttendanceStore.js';
import 'SF/student/data/CoursesGradesStore.js';
import 'SF/student/data/CoursesInterventionStore.js';
import 'SF/student/data/CoursesStatsStore.js';
import 'SF/student/data/CoursesStore.js';
import 'SF/student/data/FullStudentProfileStore.js';
import 'SF/student/data/InterventionStore.js';
import 'SF/student/data/NoteStore.js';
import 'SF/student/data/PlansDerivedStore.js';
import 'SF/student/data/StudentAttributeStore.js';
import 'SF/student/data/StudentFileStore.js';
import 'SF/student/data/StudentFolderConnectionStore.js';
import 'SF/student/data/SuccessNetworkStore.js';
import 'SF/student/data/ToDoListStore.js';
import 'SF/student/intake/CheckboxGroupQuestionPanel.js';
import 'SF/student/intake/DateFieldQuestionPanel.js';
import 'SF/student/intake/EmailFieldQuestionPanel.js';
import 'SF/student/intake/FormDataPanel.js';
import 'SF/student/intake/HeadItemPanel.js';
import 'SF/student/intake/ItemDataPanel.js';
import 'SF/student/intake/ItemDataView.js';
import 'SF/student/intake/ItemListPanel.js';
import 'SF/student/intake/ItemUtil.js';
import 'SF/student/intake/MonthFieldQuestionPanel.js';
import 'SF/student/intake/NumberFieldQuestionPanel.js';
import 'SF/student/intake/PhoneFieldQuestionPanel.js';
import 'SF/student/intake/RadioGroupQuestionPanel.js';
import 'SF/student/intake/RadioQuestionPanel.js';
import 'SF/student/intake/RatingQuestion.js';
import 'SF/student/intake/SeparatorItemPanel.js';
import 'SF/student/intake/TextAreaQuestionPanel.js';
import 'SF/student/intake/TextFieldQuestionPanel.js';
import 'SF/student/intake/TextItemPanel.js';
import 'SF/student/intake/Window.js';
import 'SF/student/intake/YearFieldQuestionPanel.js';
import 'SF/student/intake/data/IntakeLoader.js';
import 'SF/student/intake/data/ItemStore.js';
import 'SF/student/prospective/CreateForm.js';
import 'SF/student/prospective/FolderActionPanel.js';
import 'SF/student/prospective/FolderMeetingsPanel.js';
import 'SF/student/prospective/FolderNotesPanel.js';
import 'SF/student/prospective/FolderWindow.js';
import 'SF/student/prospective/SearchForm.js';
import 'SF/student/prospective/SearchResultsPanel.js';
import 'SF/student/prospective/SearchWindow.js';
import 'SF/student/prospective/bundle.js';
import 'SF/student/prospective/card/StudentCard.js';
import 'SF/student/prospective/data/SearchResultsStore.js';
import 'SF/student/prospective/data/UserStore.js';
import 'SF/student/successScore/HistoryChart.js';
import 'SF/student/successScore/HistoryMiniChart.js';
import 'SF/student/successScore/card/HistoryCard.js';
import 'SF/student/successScore/data/HistoryStore.js';
import 'SF/student/successScore/data/ScoreDefinitionStore.js';
